import { useState } from 'react';

import styled from '@emotion/styled';

import CompanyLogo from '../../../components/CompanyLogo/CompanyLogo';
import CloseMenuIcon from '../../../components/Icons/CloseMenuIcon';
import LogOutIcon from '../../../components/Icons/LogOutIcon';
import { NavBoxItem } from '../../../components/Link/Link';
import useOnLogout from '../../../hooks/auth/useOnLogout';
import { navConfig } from './navConfig';

const Nav = () => {
  const [navOpen, setNavOpen] = useState(true);
  const { logoutUser } = useOnLogout();

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  const handleLogout = (e: any) => {
    logoutUser();
  };

  return (
    <ContainerWrapper className={navOpen ? '' : 'closed-nav'}>
      {!navOpen && (
        <OpenIcon onClick={toggleNav}>
          <CloseMenuIcon />
        </OpenIcon>
      )}
      <Container className={navOpen ? '' : 'remove-nav'}>
        <CompanyLogoArea>
          <CompanyLogo />
          <CloseIcon onClick={toggleNav}>
            <CloseMenuIcon />
          </CloseIcon>
        </CompanyLogoArea>
        <NavBtnSection>
          {navConfig.map((nav) => {
            return (
              <NavBoxItem path={nav.path} key={nav.title} icon={nav.icon}>
                {nav.title}
              </NavBoxItem>
            );
          })}
        </NavBtnSection>

        <Logout onClick={handleLogout}>
          <LogOutIcon /> Logout
        </Logout>
      </Container>
    </ContainerWrapper>
  );
};

export default Nav;

const ContainerWrapper = styled.div`
  width: 258px;
  position: sticky;
  top: 0;
  z-index: 20000;
  transition: width 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};

  &.closed-nav {
    width: 0px;
  }

  @media (max-width: 884px) {
    display: none;
  }
`;

const Container = styled.nav`
  padding: 0px 0px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: sticky;
  top: 0;
  gap: 24px;
  width: 258px;
  min-width: 258px;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
  overflow: hidden;

  &.remove-nav {
    transform: translateX(-100%);
  }
`;

const Logout = styled.div`
  /* border: 1px solid blue; */
  display: flex;
  align-items: center;
  gap: 16px;
  color: ${({ theme }) => theme.palette.logirateBlack};
  font-size: 14px;
  font-weight: 500;
  margin-left: 24px;
  margin-top: auto;
  margin-bottom: 60px;
  cursor: pointer;
`;

const CompanyLogoArea = styled.div`
  display: flex;
  border-bottom: 1px solid
    ${({ theme }) => theme.palette.layoutBorderBottomColor};
  height: 82px;
  width: 100%;
  justify-content: center;
  align-items: center;

  position: relative;
`;

const NavBtnSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CloseIcon = styled.div`
  padding: 7px;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px #5c59631a;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.palette.lightBorder};
  transition: all 0.2s ease-in-out;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};

  position: absolute;
  right: 20px;

  &:hover {
    transform: translateX(-2px);
  }
`;

const OpenIcon = styled.div`
  padding: 7px;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px #5c59631a;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.palette.lightBorder};
  transition: all 0.2s ease-in-out;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};
  width: fit-content;

  position: absolute;
  right: -30px;
  top: 27px;
  z-index: 10;

  /* Delay appearance until nav is fully closed */
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s ease-in-out 0.3s,
    visibility 0s 0.3s,
    transform 0.2s ease-in-out;

  animation: fadeIn 0.2s ease-in-out 0.3s forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
      visibility: hidden;
    }
    to {
      opacity: 1;
      visibility: visible;
    }
  }

  &:hover {
    transform: translateX(2px);
  }

  & > svg {
    transform: rotate(180deg);
  }
`;
